import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchListings } from '../actions/serviceActions/proposal'
import { fetchWssid } from '../actions/serviceActions/common'
import WithS3Service from './Common/WithS3Service'
import Test from '../components/Test'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  const actions = {
    fetchListings,
    fetchWssid
  }

  return {
    ...bindActionCreators(actions, dispatch)
  }
}

const MappedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(WithS3Service(Test))

export default MappedContainer
